export default {
    pluginName: 'market',
    backendDataType: 'MR',
    rowIdKey: 'DOC_ID',
    edit: 'data_edit',
    count: 'mr_count',
    totalCount: 'total_mr_count',
    fieldI18nKey: 'commonMarket',
    maxPerFolder: 'max_mr_per_folder',
    maxOp: 'max_op_mr',
    staticFields: ['TITLE'],
    dataId: 'ID',
};
